import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { SITE, NAV } from "../siteConfig";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-forest text-limestone">
    <div className="mx-auto max-w-6xl px-5 py-16 md:px-8 md:py-24">
      <p className="font-serif text-4xl leading-tight md:text-6xl" data-testid="footer-tagline">
        Land. Mapped. <span className="italic text-sage">Understood.</span>
      </p>

      <div className="mt-14 grid gap-10 border-t border-limestone/15 pt-10 md:grid-cols-3">
        <div>
          <Logo dark />
          <p className="mt-5 max-w-xs text-sm leading-relaxed text-limestone/70">
            Clear aerial mapping and visual land records for rural estates, landowners and
            land-management professionals.
          </p>
        </div>
        <nav aria-label="Footer navigation">
          <p className="eyebrow text-sage">Explore</p>
          <ul className="mt-4 space-y-2.5">
            {NAV.map((item) => (
              <li key={item.to}>
                <Link
                  to={item.to}
                  data-testid={`footer-nav-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
                  className="link-underline text-sm text-limestone/85 hover:text-limestone"
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
        <div>
          <p className="eyebrow text-sage">Service Area</p>
          <p className="mt-4 text-sm leading-relaxed text-limestone/85" data-testid="footer-service-area">
            {SITE.base}, covering the {SITE.areas.slice(0, -1).join(", ")} and {SITE.areas[SITE.areas.length - 1]}.
          </p>
          <p className="mt-4 text-sm text-limestone/70" data-testid="footer-contact">
            {SITE.email ? (
              <>
                Email:{" "}
                <a href={`mailto:${SITE.email}`} data-testid="footer-email-link" className="link-underline text-limestone">
                  {SITE.email}
                </a>
              </>
            ) : (
              <>The enquiry form is currently the best way to reach us.</>
            )}
          </p>
        </div>
      </div>

      <div className="mt-14 space-y-3 border-t border-limestone/15 pt-8 text-xs leading-relaxed text-limestone/55">
        <p>
          Aerial imagery and mapping outputs are illustrative and depend on the project, capture method and
          processing requirements. They are not a substitute for a chartered survey, legal boundary
          determination, planning advice or professional ecological or forestry assessment.
        </p>
        <div className="flex flex-wrap items-center justify-between gap-3">
          <p>© {new Date().getFullYear()} {SITE.name}. All rights reserved.</p>
          <Link to="/privacy" data-testid="footer-privacy-link" className="link-underline hover:text-limestone">
            Privacy policy
          </Link>
        </div>
      </div>
    </div>
  </footer>
);
